import { useState, useEffect, useContext } from "react";
import SearchProvider from "../../Provider/SearchProvider";
import ClinicDetailsCard from "../../UI/ClinicDetailsCard/ClinicDetailsCard";
import { Breadcrumb, Button, Select, Pagination } from "antd";
import Spinder from "../../UI/Spiner/Spinder";
import Meta from "../../Meta/Meta";
const ClinicList = () => {
  const {
    searchLoader,
    getSearchData,
    searchData,
    searchTable,
    setSearchTable,
    provinceDropdown,
    provinceLoaderDropdown,
    provinceListDropdown,
    selectedDropdown,
    setSelectedDropdown,
    // districtDropdown,
    districtDropdown,
    districtListDropdown,
    setDistrictListDropdown,
    districtLoaderDropdown,
    // secretariatDropdown,
    secretariatsDropdown,
    secretariatListDropdown,
    setSecretariatListDropdown,
    secretariatLoaderDropdown,
    setSecretariatLoaderDropdown,
    getSearchDataDropdown,
    searchLoaderDropdown,
  } = useContext(SearchProvider);

  useEffect(() => {
    getSearchData();
    provinceDropdown();
    setSelectedDropdown({
      province_id: "",
      district_id: "",
      secretariats_id: "",
    });
  }, []);
  useEffect(() => {
    getSearchData();
  }, [searchTable]);

  const handleSpecificPage = (page) => {
    setSearchTable({
      ...searchTable,
      page: page,
    });
  };
  // console.log("searchData", searchData);
  console.log("selectedDropdown", selectedDropdown);
  return (
    <>
      <Meta slug={"clinic"} />
      <section className="my-[5vh]">
        {searchLoader ? (
          <Spinder />
        ) : (
          <div className="container">
            <Breadcrumb
              separator="/"
              items={[
                {
                  title: "Home",
                  href: "/",
                },
                {
                  title: `Clinic`,
                },
              ]}
            />
            <div className="mt-[2rem] flex gap-[1rem]">
              <div className="flex items-center gap-[1rem]">
                <h3 className="font-normal text-[16px] text-lightgray">
                  Province
                </h3>
                <Select
                  size="large"
                  showSearch
                  value={selectedDropdown.province_id || null}
                  placeholder="Select a Province"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={provinceLoaderDropdown}
                  options={provinceListDropdown}
                  onChange={(value) => {
                    setSelectedDropdown({
                      ...selectedDropdown,
                      province_id: value,
                      district_id: null,
                      secretariats_id: null,
                    });
                    setDistrictListDropdown([]);
                    setSecretariatListDropdown([]);
                    districtDropdown(value);
                  }}
                  onSearch={(value) => provinceDropdown(value)}
                />
              </div>
              <div className="flex items-center gap-[1rem]">
                <h3 className="font-normal text-[16px] text-lightgray">
                  District
                </h3>
                <Select
                  showSearch
                  size="large"
                  value={selectedDropdown.district_id || null}
                  placeholder="Select a district"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={districtLoaderDropdown}
                  options={districtListDropdown}
                  onChange={(value) => {
                    setSelectedDropdown({
                      ...selectedDropdown,
                      district_id: value,
                      secretariats_id: null,
                    });
                    setSecretariatListDropdown([]);
                    secretariatsDropdown(value);
                  }}
                />
              </div>
              <div className="flex items-center gap-[1rem]">
                <h3 className="font-normal text-[16px] text-lightgray">
                  Secretariat
                </h3>
                <Select
                  showSearch
                  size="large"
                  value={selectedDropdown.secretariats_id || null}
                  placeholder="Select a Secretariat"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={secretariatListDropdown}
                  loading={secretariatLoaderDropdown}
                  onChange={(value) => {
                    setSelectedDropdown({
                      ...selectedDropdown,
                      secretariats_id: value,
                    });
                  }}
                />
              </div>
              <Button
                type="primary"
                size="large"
                style={{ width: "10rem", backgroundColor: "#268F81" }}
                onClick={() => getSearchDataDropdown(selectedDropdown)}
              >
                Search
              </Button>
            </div>
            <div className="my-[2rem]">
              {searchLoaderDropdown ? (
                <Spinder />
              ) : (
                <>
                  {searchData?.data?.length === 0 && (
                    <h1 className="text-center font-primary text-[18px] my[2rem]">
                      No Data Found
                    </h1>
                  )}
                  {searchData?.data?.map((item) => {
                    return (
                      <>
                        <ClinicDetailsCard
                          key={item?._id}
                          data={item}
                          appointment={false}
                        />
                      </>
                    );
                  })}
                </>
              )}
              {searchData?.data?.length > 0 && (
                <div className="flex gap-[1rem] justify-center ">
                  <button
                    className={`cursor-pointer px-[1rem] py-[0.5rem] rounded-[5px] text-white bg-primary font-primary font-normal text-[1.5rem] hover:bg-white hover:text-primary transition-all duration-200 ${
                      searchData?.paginator?.prev === null
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    } `}
                    onClick={() => {
                      if (searchData?.paginator?.prev !== null) {
                        const prevPage = searchData?.paginator?.prev;
                        setSearchTable({
                          ...searchTable,
                          page: prevPage,
                        });
                      }
                    }}
                  >
                    prev
                  </button>
                  <button
                    className={`px-[1rem] py-[0.5rem] rounded-[5px] text-white bg-primary font-primary font-normal text-[1.5rem]  hover:bg-white hover:text-primary transition-all duration-200 ${
                      searchData?.paginator?.next === null
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                    onClick={() => {
                      // Increment the current page by 1
                      if (searchData?.paginator?.next !== null) {
                        const nextPage = searchData?.paginator?.next;
                        setSearchTable({
                          ...searchTable,
                          page: nextPage,
                        });
                      }
                    }}
                  >
                    {" "}
                    next
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default ClinicList;
